<template>
  <el-form :model="form" :rules="rules" ref="form">
    <el-form-item label="手机号：">
      <span>{{ step1Data.phoneWithStar }}</span>
    </el-form-item>
    <el-form-item prop="validationCode">
      <div class="valicode-row">
        <el-input v-model="form.validationCode" @keyup.enter.native="primaryBtnClick" class="valicode-input" placeholder="验证码" maxlength="4" />
        <div class="valicode-pic">
          <img :src="byteImg" @click="getValiCodePic" />
        </div>
      </div>
    </el-form-item>
    <el-form-item prop="verifyCode">
      <el-input
        v-model="form.verifyCode"
        @keyup.enter.native="primaryBtnClick"
        style="width: 200px; vertical-align: middle"
        maxlength="6"
        placeholder="填写验证码"
      >
        <span class="el-input__icon" slot="prefix" style="display: inline-block; line-height: 45px">
          <img src="@/assets/images/verify_code.png" width="16px" height="16px" />
        </span>
      </el-input>

      <el-button
        style="width: 128px; height: 40px; vertical-align: middle; margin-left: 12px"
        @click="getPhoneLoginVerifyCode"
        :disabled="!!getPhoneVerifyCodeTimmer"
      >
        {{ getPhoneVerifyCodeBtnText }}
      </el-button>
    </el-form-item>
    <el-form-item class="mt-24">
      <PrimaryBtn :loading="loading" @click="primaryBtnClick"> 下一步 </PrimaryBtn>
    </el-form-item>
  </el-form>
</template>

<script>
import PrimaryBtn from '../../components/LoginPrimaryBtn';
import { forgetPasswordStep2, forgetPasswordGetPicValiCode, forgetPasswordGetSmsValiCode } from '@/api/login-api';
import { cloneDeep } from 'lodash';
export default {
  name: 'StepSecond',
  components: {
    PrimaryBtn,
  },
  props: {
    step1Data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        verifyCode: '',
        validationCode: '',
      },
      rules: {
        validationCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        verifyCode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }],
      },
      loading: false,
      byteImg: '',
      getPhoneVerifyCodeTimmer: null,
      getPhoneVerifyCodeCD: 60,
    };
  },
  computed: {
    getPhoneVerifyCodeBtnText() {
      if (!this.getPhoneVerifyCodeTimmer) {
        return '获取验证码';
      }
      return `(${this.getPhoneVerifyCodeCD < 10 ? '0' : ''}${this.getPhoneVerifyCodeCD})s`;
    },
  },
  mounted() {
    this.getValiCodePic();
  },
  methods: {
    async getValiCodePic() {
      try {
        const src = forgetPasswordGetPicValiCode();
        this.byteImg = src;
      } catch (error) {
        console.log(error);
      }
    },
    async getPhoneLoginVerifyCode() {
      this.setupPhoneVerifyCodeCD();
      const { validationCode } = this.form;
      const { phoneWithEncode, token, phoneWithStar } = this.step1Data;
      forgetPasswordGetSmsValiCode({
        phoneNum: phoneWithEncode,
        token,
        status: 1,
        validationCode,
      })
        .then(res => {
          if (res.result !== 1) {
            this.clearPhoneVerifyCodeCD();
            return false;
          }
          this.$message.success(`验证码已发送至${phoneWithStar}`);
        })
        .catch(() => {
          this.clearPhoneVerifyCodeCD();
        });
    },
    setupPhoneVerifyCodeCD() {
      this.getPhoneVerifyCodeTimmer = setInterval(() => {
        if (this.getPhoneVerifyCodeCD < 1) {
          this.clearPhoneVerifyCodeCD();
        } else {
          this.getPhoneVerifyCodeCD -= 1;
        }
      }, 1000);
    },
    clearPhoneVerifyCodeCD() {
      this.getPhoneVerifyCodeTimmer && clearInterval(this.getPhoneVerifyCodeTimmer);
      this.getPhoneVerifyCodeTimmer = null;
      this.$nextTick(() => {
        this.getPhoneVerifyCodeCD = 60;
      });
    },
    primaryBtnClick() {
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        this.loading = true;
        const { phoneWithEncode, accountId } = this.step1Data;
        const { verifyCode } = this.form;
        forgetPasswordStep2({
          accountId,
          encodePhoneNum: phoneWithEncode,
          identityCode: verifyCode,
        })
          .then(res => {
            const { data, result } = res;
            this.loading = false;
            if (result !== 1) {
              return false;
            }
            this.$emit('on-success', cloneDeep(data));
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
  },
  beforeDestroy() {
    this.clearPhoneVerifyCodeCD();
  },
};
</script>
